// WIP: soon to be removed, after users withdraw and we close the liquidator vault.
/** https://app.paradex.trade/vaults/0x4c977a2da284d646e4efddbc7048ed07b8d217ede80a97d3f533188bbf843c5 */
export const LIQUIDATOR_VAULT_ADDRESS =
  '0x4c977a2da284d646e4efddbc7048ed07b8d217ede80a97d3f533188bbf843c5';
